import { jsx as _jsx } from "@emotion/react/jsx-runtime";
// External dependencies
import { useState, createContext, useEffect } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
// Internal dependencies
import { auth } from '.';
// User context
export const UserContext = createContext(null);
/**
 * User Provider element
 * @param {any} props
 * @returns {ReactJSXElement}
 */
export const UserProvider = function ({ children }) {
    // User state
    const [user, setUser] = useState(auth.currentUser);
    // Update user when Auth State changed
    useEffect(() => {
        onAuthStateChanged(auth, (user) => {
            if (user) {
                setUser(user);
            }
            else {
                setUser(null);
            }
            ;
        });
    });
    return (_jsx(UserContext.Provider, Object.assign({ value: user }, { children: children })));
};
